/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Options_Generalenquiry2Inputs */

const ja_contact_formtype_options_generalenquiry2 = /** @type {(inputs: Contact_Formtype_Options_Generalenquiry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`弊社へのお問い合わせ`)
};

const en_contact_formtype_options_generalenquiry2 = /** @type {(inputs: Contact_Formtype_Options_Generalenquiry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Enquiry`)
};

/**
* | output |
* | --- |
* | "General Enquiry" |
*
* @param {Contact_Formtype_Options_Generalenquiry2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_options_generalenquiry2 = /** @type {((inputs?: Contact_Formtype_Options_Generalenquiry2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Options_Generalenquiry2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_options_generalenquiry2(inputs)
	return en_contact_formtype_options_generalenquiry2(inputs)
});
export { contact_formtype_options_generalenquiry2 as "contact_formType_options_generalEnquiry" }